import { render, staticRenderFns } from "./BaseMitMenuFooter.vue?vue&type=template&id=3bcf3840&scoped=true"
import script from "./BaseMitMenuFooter.vue?vue&type=script&lang=js"
export * from "./BaseMitMenuFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf3840",
  null
  
)

export default component.exports